<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      :style="{
        'width': $q.screen.gt.xs ? '500px' : '100%',
        'max-width': '500px'
      }"
    >
      <q-form
        ref="formRef"
      >
        <q-card-section v-if="giftCardSale">
          <div class="column">
            <div
              class="row items-center q-gutter-sm q-mx-xs"
              style="margin-bottom: 32px;"
            >
              <div class="col text-h6">
                {{ formTitle }}
              </div>
              <q-btn
                class="col-auto"
                icon="close"
                flat
                round
                dense
                @click="close"
              />
            </div>
            <div class="row q-col-gutter-sm items-start">
              <!-- NOTE: We must pass :model="sectionClone" to all of these for the reasons explained
            in the code comments for `initializeSectionClone()` -->
              <model-form-input
                :model="sectionClone"
                :field="`config.giftCardSales[${index}].name`"
                value-type="String"
                class="col-6"
                label="Name"
                :rules="[val => !!val || 'Field is required']"
              />
              <model-form-input
                :model="sectionClone"
                :field="`config.giftCardSales[${index}].amount`"
                value-type="Number"
                :disable="giftCardSale.custom"
                class="col-6 q-pb-md"
                label="Amount"
                type="number"
                step="1"
                :prefix="currentCircuit.localeCurrencySymbol"
                :rules="[val => !!val || 'Field is required']"
              />
            </div>
            <div class="row q-gutter-sm">
              <model-form-toggle
                :model="sectionClone"
                :field="`config.giftCardSales[${index}].custom`"
                value-type="Boolean"
                class="col-3 q-mb-md q-ml-auto"
                label="Custom"
                left-label
                bottom-slots
                size="lg"
              />
              <model-form-input
                :model="sectionClone"
                :field="`config.giftCardSales[${index}].customMinimumAmount`"
                value-type="Number"
                :disable="!giftCardSale.custom"
                class="col-4"
                label="Minimum Amount"
                type="number"
                step="1"
                :prefix="currentCircuit.localeCurrencySymbol"
                :rules="[val => !!val || val < 1 || 'Field must be greater than 0']"
                bottom-slots
              />
              <model-form-input
                :model="sectionClone"
                :field="`config.giftCardSales[${index}].customMaximumAmount`"
                value-type="Number"
                :disable="!giftCardSale.custom"
                class="col-4"
                label="Maximum Amount"
                type="number"
                step="1"
                :prefix="currentCircuit.localeCurrencySymbol"
                :rules="[val => !!val || val > 1000 || 'Field cannot exceed 1000']"
                bottom-slots
              />
            </div>
            <div class="row q-col-gutter-sm items-start">
              <div class="col-6 column q-col-gutter-sm">
                <model-form-image-uploader
                  :model="sectionClone"
                  :field="`config.giftCardSales[${index}].image`"
                  value-type="String"
                  class="col"
                  min-height="150px"
                  :image-url="giftCardSaleImageUrl(localizedGiftCardSale.image, localizedGiftCardSale.color)"
                />
                <div class="col-auto row justify-center items-center">
                  <color-picker
                    color-name="custom"
                    :color-hex="giftCardSale.color"
                    :disable="!giftCardSale.image || section.isTranslation"
                    @update:model-value="colorHex => giftCardSale.color = colorHex"
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="text-h5">
                  Preview:
                </div>
                <gift-card-sale-card
                  :gift-card-sale="localizedGiftCardSale"
                />
              </div>
            </div>
          </div>
        </q-card-section>
        <q-card-actions class="row justify-end q-ma-sm">
          <q-btn
            :label="formSaveLabel"
            color="primary"
            @click="save()"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { createGiftCardSale, giftCardSaleImageUrl } from 'src/models/gift-card/GiftCardSale'
import ColorPicker from 'src/modules/admin/components/ColorPicker'
import SectionConfigArrayElementFormMixin from 'src/modules/admin/components/ModelForm/mixins/SectionConfigArrayElementFormMixin'
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'
import GiftCardSaleCard from 'src/modules/consumer/components/GiftCardSaleCard'

export default {
  name: 'GiftCardSaleForm',
  components: {
    ColorPicker,
    GiftCardSaleCard
  },
  mixins: [SectionConfigArrayElementFormMixin, FormValidationMixin],
  configuration: ['currentCircuit', 'currentSite'],
  emits: ['save'],
  computed: {
    // required by mixin
    field () {
      return 'giftCardSales'
    },
    // required by mixin
    typeName () {
      return 'Gift Card Sale'
    },
    giftCardSale () {
      return this.currentArrayElement
    },
    localizedGiftCardSale () {
      if (!this.giftCardSale) return null
      const localizedGiftCardSale = { ...this.giftCardSale }
      localizedGiftCardSale.image = this.giftCardSale[this.localizeKey('image')] || this.giftCardSale.image
      return localizedGiftCardSale
    }
  },
  created () {
    _.extend(this, { giftCardSaleImageUrl })
  },
  methods: {
    // required by mixin
    getElementDefaultProps () {
      return createGiftCardSale()
    },
    save () {
      this.validateForm(() => {
        this.$emit('save', _.clone(this.giftCardSale))
        this.close()
      })
    }
  }
}

</script>
